module.exports = __webpack_public_path__ + "img/small-6.2ae688f4.jpg";